/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Program_CInputs */

const en_subtitle_export_program_c = /** @type {(inputs: Subtitle_Export_Program_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program C`)
};

const fr_subtitle_export_program_c = /** @type {(inputs: Subtitle_Export_Program_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme C`)
};

const de_subtitle_export_program_c = /** @type {(inputs: Subtitle_Export_Program_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programm C`)
};

const it_subtitle_export_program_c = /** @type {(inputs: Subtitle_Export_Program_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programma C`)
};

const ru_subtitle_export_program_c = /** @type {(inputs: Subtitle_Export_Program_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Программа C`)
};

const es_subtitle_export_program_c = /** @type {(inputs: Subtitle_Export_Program_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programa C`)
};

const zh_cn2_subtitle_export_program_c = /** @type {(inputs: Subtitle_Export_Program_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`程序C`)
};

const ja_subtitle_export_program_c = /** @type {(inputs: Subtitle_Export_Program_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プログラムC`)
};

const hi_subtitle_export_program_c = /** @type {(inputs: Subtitle_Export_Program_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम सी`)
};

const pt_pt2_subtitle_export_program_c = /** @type {(inputs: Subtitle_Export_Program_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programa C`)
};

/**
* | output |
* | --- |
* | "Program C" |
*
* @param {Subtitle_Export_Program_CInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_program_c = /** @type {((inputs?: Subtitle_Export_Program_CInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Program_CInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_program_c(inputs)
	if (locale === "de") return de_subtitle_export_program_c(inputs)
	if (locale === "it") return it_subtitle_export_program_c(inputs)
	if (locale === "ru") return ru_subtitle_export_program_c(inputs)
	if (locale === "es") return es_subtitle_export_program_c(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_program_c(inputs)
	if (locale === "ja") return ja_subtitle_export_program_c(inputs)
	if (locale === "hi") return hi_subtitle_export_program_c(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_program_c(inputs)
	return en_subtitle_export_program_c(inputs)
});